$(document).ready(function () {

  function handleUserSaveAjaxError(xhr) {
    console.error('user-save AJAX failed', xhr && xhr.status, xhr && xhr.responseText);
    alert('Ups, něco se porouchalo');
  }

  let userOptionForm = $('#userOption');
  let modalLoginForm = $('#modalLoginForm');
  let recoverForm = $('#recoverForm');
  let resetPasswordForm = $('#resetPasswordForm');
  let registrationForm = $('#registrationForm');
  let newsletterForm = $('#newsletterSubscribeForm');
  let nlwSubscribeForm = $('#nlwSubscribeForm');

  jQuery.validator.addMethod(
    'regex',
    function (value, element, regexp) {
      if (regexp.constructor != RegExp)
        regexp = new RegExp(regexp);
      else if (regexp.global)
        regexp.lastIndex = 0;
      return this.optional(element) || regexp.test(value);
    }, "erreur expression reguliere"
  );

  // Formulář pro nastavení usera
  if (userOptionForm.length) {
    userOptionForm.validate({
      focusInvalid: true,
      rules: {
        password: {
          minlength: 8,
          regex: '((?=.*[0-9])(?=.*[A-Z]))'
        },
        confirmpassword: {
          equalTo: '#password'
        }
      },
      messages: {
        password: {
          required: 'Povinné pole',
          regex: 'Heslo musí obsahovat číslici a velké písmeno',
          minlength: 'Heslo musí obsahovat minimálně 8 znaků'
        },
        confirmpassword: {
          required: 'Povinné pole',
          equalTo: 'Hesla se musí shodovat'
        }
      },
      errorPlacement: function(error, element) {
        var wrapper = element.closest('.input-wrapper');
        var errorLabel = wrapper.find('.error-label');
        if (errorLabel.length) {
          errorLabel.html(error.text());
        } else {
          error.insertBefore(element);
        }
      },
      success: function(label, element) {
        var wrapper = $(element).closest('.input-wrapper');
        var errorLabel = wrapper.find('.error-label');
        if (errorLabel.length) {
          errorLabel.html('');
        }
      }
    })
  }

  $('body').on('click', '.user-save-btn', function (e) {
  let $btn = $(this);
  let form = $btn.closest('form');
  let formId = form.attr('id');
  let $wrapper = $btn.parent('.user-btn_wrapper');

    //formular s heslem
     if (formId === 'userOption') {
      if (userOptionForm.valid()) {
        e.preventDefault();

        $btn.addClass('is-loading');

        $.ajax({
          url: form.attr('action'),
          type: 'post',
          dataType: 'json',
          data: form.serialize(),
          success: function (data) {
            if (data.status === 'ok') {
              form[0].reset();

              $('#userConfirmSave').addClass('active').closest('.modal-wrapper').addClass('open');
              $('#userConfirmSave').find('.main-form-button').focus();
              $('#modalLogin .close, #modalLogin .js-close-modal').attr('data-redirect', '/');
              $btn.prop('disabled', true);

              localStorage.removeItem('RegionalContentLoaded');
              localStorage.removeItem('regionCheckboxStates');
            } else {
              alert('Ups, něco se porouchalo');
            }
          },
          error: handleUserSaveAjaxError,
        }).always(function () {
          $btn.removeClass('is-loading');
        });


      } else {
        userOptionForm.validate().focusInvalid();

      }
    } else if (formId === 'userInfo') {
      //formular s osobnimi udaji a newsletter
      e.preventDefault();

      if ($wrapper.data('timeoutId')) {
        clearTimeout($wrapper.data('timeoutId'));
        $wrapper.removeData('timeoutId');
      }

      $wrapper.removeClass('visible fadeout');
      $btn.addClass('is-loading');

      $.ajax({
        url: form.attr('action'),
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          if (data.status === 'ok') {
            $btn.prop('disabled', true);

            $wrapper.addClass('visible');
            const timeoutId = setTimeout(function () {
              $wrapper.addClass('fadeout');
            }, 4000);

            $wrapper.data('timeoutId', timeoutId);

            $wrapper.one('transitionend', function () {
              if ($wrapper.hasClass('fadeout')) {
                $wrapper.removeClass('visible fadeout');
              }
            });
          } else {
            alert('Ups, něco se porouchalo');
          }
        },
        error: handleUserSaveAjaxError,
      }).always(function () {
        $btn.removeClass('is-loading');
      });
    }

    //formular s regionalnim obsahem
    else if (formId === 'userRegionalContentSettings') {
      e.preventDefault();

      if ($wrapper.data('timeoutId')) {
        clearTimeout($wrapper.data('timeoutId'));
        $wrapper.removeData('timeoutId');
      }

      $wrapper.removeClass('visible fadeout');
      $btn.addClass('is-loading');

      $.ajax({
        url: form.attr('action'),
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          if (data.status === 'ok') {
            $btn.prop('disabled', true);

            //prmitneme ulozena pole do horniho panelu regionalniho obsahu
            saveRegionStatesAndSync();

            $wrapper.addClass('visible');
            const timeoutId = setTimeout(function () {
              $wrapper.addClass('fadeout');
            }, 4000);

            $wrapper.data('timeoutId', timeoutId);

            $wrapper.one('transitionend', function () {
              if ($wrapper.hasClass('fadeout')) {
                $wrapper.removeClass('visible fadeout');
              }
            });
          } else {
            alert('Ups, něco se porouchalo');
          }
        },
        error: handleUserSaveAjaxError,
      }).always(function () {
        $btn.removeClass('is-loading');
      });
    }
  });


    // regionální obsah - synchronizujeme klikání inputů s mapkou a naopak
  (function inputsRegionalContentSync() {
    const wrapper = document.querySelector('.user__input-wrapper.RegionalContentSettings');
    if (!wrapper) return;

    const mapRegions = wrapper.querySelectorAll('#interactive-map [data-checkbox-id]');

    mapRegions.forEach(region => {
      const checkboxId = region.getAttribute('data-checkbox-id');
      const checkbox = wrapper.querySelector(`input[type="checkbox"][value="${CSS.escape(checkboxId)}"]`);

      if (!checkbox) return;

      // nastavení počátečního stavu
      region.classList.toggle('selected', checkbox.checked);

      region.addEventListener('click', () => {
        checkbox.checked = !checkbox.checked;
        region.classList.toggle('selected', checkbox.checked);
      });

      region.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          checkbox.checked = !checkbox.checked;
          region.classList.toggle('selected', checkbox.checked);
        }
      });

      checkbox.addEventListener('change', () => {
        region.classList.toggle('selected', checkbox.checked);
      });
    });
  })();

  //regionální obsah - po ulozeni nastaveni regionalniho obashu synchronizujeme s horním panelem
  function saveRegionStatesAndSync() {
    const userWrapper = document.querySelector('.user__input-wrapper.RegionalContentSettings .regional-content-container');
    if (!userWrapper) return;

    const storedState = {};
    const userChecked = userWrapper.querySelectorAll('input[type="checkbox"]:checked');

    userChecked.forEach(input => {
      storedState[input.value] = true;
    });

    const allInputs = userWrapper.querySelectorAll('input[type="checkbox"]');
    allInputs.forEach(input => {
      if (!(input.value in storedState)) {
        storedState[input.value] = false;
      }
    });

    localStorage.setItem('regionCheckboxStates', JSON.stringify(storedState));

    syncRegionsFromStorage();
    updateSearchLinkFromCheckboxes();
    updateButtonStates();
    if (typeof window.highlightArticlesByRegion === 'function') {
      window.highlightArticlesByRegion();
    }
  }


  //aktivace tlacitka save
  (function saveButtonEnable() {
    const userSections = document.querySelectorAll('.user-section');
    if (!userSections.length) return;

    userSections.forEach(section => {
      const btn = section.querySelector('.user-save-btn');
      if (!btn) return;

      const enableButton = e => {
        if (e.target.matches('input, select, textarea')) {
          btn.removeAttribute('disabled');
        }
      };

      section.addEventListener('input', enableButton);
      section.addEventListener('change', enableButton);

      const mapRegions = section.querySelectorAll('svg [data-checkbox-id]');
      mapRegions.forEach(region => {
        region.addEventListener('click', () => {
          btn.removeAttribute('disabled');
        });
        region.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            btn.removeAttribute('disabled');
          }
        });
      });
    });
  })();

  // sticky navigace - skrolovani na danou sekci + zafocusovani na 1. mozny element
  (function userSectionScroll() {
  let activatedByKeyboard = false;

  $('.profil-submenu a').on('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
          activatedByKeyboard = true;
      }
  });

  $('.profil-submenu a').on('click', function(e) {
      let target = $(this).prop('hash');

      if (target.length > 1 && $(target).length) {
          e.preventDefault();

          let rectTop = $(target)[0].getBoundingClientRect().top;
          let offsetTop = window.scrollY + rectTop - 160;

          $('html, body').animate({
              scrollTop: offsetTop
          }, 400, function() {
              if (activatedByKeyboard) {
                  let focusable = $(target).find(
                      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
                  ).first();

                  if (focusable.length) {
                      focusable.focus();
                  }
              }
              activatedByKeyboard = false; // reset
          });
      }
  });
  })();

  // zvyraznovani aktualni sekce nastaveni podle skrollovani
  (function highlightStickyItem() {
    const tocLinks = document.querySelectorAll('.profil-submenu a');
    if (!tocLinks.length) return;

    const headings = Array.from(tocLinks)
      .map(link => {
        const id = link.hash ? link.hash.substring(1) : null;
        return id ? document.getElementById(id) : null;
      })
      .filter(Boolean);

    if (!headings.length) return;

    function onScroll() {
      //const midpoint = window.innerHeight * 0.5;
      const midpoint = 170;

      let activeId = null;
      let bestTop = -Infinity;

      headings.forEach(heading => {
        const rectTop = heading.getBoundingClientRect().top;

        if (rectTop <= midpoint && rectTop > bestTop) {
          bestTop = rectTop;
          activeId = heading.id;
        }
      });

      tocLinks.forEach(link => {
        const linkId = link.hash ? link.hash.substring(1) : null;
        link.classList.toggle('current-section', linkId === activeId);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
   })();

  //Pristupnost - kdyz prejdu enterem na nastaveni/ vysledky kalkulacky, pokracuji focusem v user-section
  (function focusAccessibility() {
    const links = document.querySelectorAll('a.nastaveni, a.vysledky-kalkulacky');
    links.forEach(link => {
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          localStorage.setItem('enter-detected', 'true');
        }
      });
    });

  if (localStorage.getItem('enter-detected') === 'true') {
    const body = document.body;

    //pro nastaveni a vysledky kalkulacky
    if (body.classList.contains('js-uzivatelsky-profil') || body.classList.contains('js-vysledky-kalkulaci-kurzovych-rizik')) {
      const handler = function (e) {
        if (e.key === 'Tab') {
          e.preventDefault();

          const container = document.querySelector('.user .user-content');
          if (container) {

            console.log('true');
            const focusable = container.querySelector(
                  'a[href]:not([disabled]), button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
                );
            if (focusable) {
              focusable.focus();
            }
          }

          localStorage.removeItem('enter-detected');
          document.removeEventListener('keydown', handler);
        }
      };

      document.addEventListener('keydown', handler);
    } else {
      // jiná stránka - vždy smažeme localStorage
      localStorage.removeItem('enter-detected');
    }
  }
  })();


  $('body').on('keyup', '#userOption input', function () {
    if (!$(this).val()) {
      $(this).removeClass('valid').attr('aria-invalid', '')
    }
  });

  // Modální okno pro přihlášení
  if (modalLoginForm.length) {
    modalLoginForm.validate({
      focusInvalid: true,
      messages: {
        login_email: {
          required: 'Povinné pole',
          email: 'Zadejte emailovou adresu'
        },
        login_password: {
          required: 'Povinné pole'
        }
      },
      errorPlacement: function(error, element) {
        var wrapper = element.closest('.input-wrapper');
        var errorLabel = wrapper.find('.error-label');
        if (errorLabel.length) {
          errorLabel.html(error.text());
        } else {
          error.insertBefore(element);
        }
      },
      success: function(label, element) {
        var wrapper = $(element).closest('.input-wrapper');
        var errorLabel = wrapper.find('.error-label');
        if (errorLabel.length) {
          errorLabel.html('');
        }
      }
    })
  }

  // Globální funkce pro odeslání login formuláře (používá se i z reCAPTCHA callbacku)
  window.submitLoginForm = function(form) {
    if (!form || !form.length) {
      form = modalLoginForm;
    }

    if (modalLoginForm.valid()) {
      form.find('button.login-btn').addClass('is-loading');
      form.find('.modal-message-box').addClass('hidden');

      $.ajax({
        url: form.attr('action'),
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          if (data.status === 'ok') {
            if (data.isAdmin) {
              window.location.href = '/wp-admin';
            } else {
              window.location.reload();
            }
          } else {
            form.find('.modal-message-box.wrong-password-email').removeClass('hidden');
            form.find('input').filter(':visible:not([disabled]):first').focus();
          }
        },
        error: function () {
          let newForm = $('<form style="display: none;" action="/wp-login.php" method="POST">' +
            '<input type="text" name="log" value="' + form.find('input[name="login_email"]').val() + '" />' +
            '<input type="password" name="pwd" value="' + form.find('input[name="login_password"]').val() + '" />' +
            '</form>');
          newForm.appendTo('body').submit();
        }
      }).always(function() {
        form.find('button.login-btn').removeClass('is-loading');
      });
    } else {
      modalLoginForm.validate().focusInvalid();
    }
  };

  // proces prihlaseni
  $('body').on('click', '#modalLogin .login-btn', function (e) {
    e.preventDefault();
    let form = $(this).closest('form');
    window.submitLoginForm(form);
  });

  $('body').on('click', '#modalLogin .recover a', function () {
    $('#modalLogin').removeClass('active');
    $('#recoverModal').addClass('active').find('input').filter(':first').focus();
  });

  $('body').on('click', '#modalLogin .no-account', function () {
    $('#modalLogin').removeClass('active');
    $('#modalRegister').addClass('active').find('input').filter(':first').focus();
  });

  // Modální okno pro obnovení hesla
  if (recoverForm.length) {
    recoverForm.validate({
      focusInvalid: true,
      messages: {
        recover_email: {
          required: 'Povinné pole',
          email: 'Zadejte emailovou adresu'
        }
      },
      errorPlacement: function(error, element) {
        var wrapper = element.closest('.input-wrapper');
        var errorLabel = wrapper.find('.error-label');
        if (errorLabel.length) {
          errorLabel.html(error.text());
        } else {
          error.insertBefore(element);
        }
      },
      success: function(label, element) {
        var wrapper = $(element).closest('.input-wrapper');
        var errorLabel = wrapper.find('.error-label');
        if (errorLabel.length) {
          errorLabel.html('');
        }
      }
    });
  }

  $('body').on('click', '#recoverForm .recover-btn', function (e) {
    if (recoverForm.valid()) {
      e.preventDefault();

      let form = $(this).closest('form');
      form.find('button.recover-btn').addClass('is-loading');
      form.find('.modal-message-box').addClass('hidden');

      $.ajax({
        url: form.attr('action'),
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {

          if (data.status === 'ok') {
            form.find();
            form.find('.modal-message-box.reset-password-success').removeClass('hidden');
            form.closest('.modal').find('.js-modal-close').focus();

          } else {
            form.find('.modal-message-box.reset-password-fail').removeClass('hidden');
            form.find('input').filter(':visible:not([disabled]):first').focus();
            form[0].reset();
          }
        }
      }).always(function() {
      form.find('button.recover-btn').removeClass('is-loading');
    });
    } else {
      recoverForm.validate().focusInvalid();
    }
  });

  // Modální okno pro registraci
    if (registrationForm.length) {
      registrationForm.validate({
        focusInvalid: true,
        rules: {
          registration_password: {
            minlength: 8,
            regex: '((?=.*[0-9])(?=.*[A-Z]))'
          },
          registration_confirm: {
            equalTo: '#registerPassword'
          }
        },
        messages: {
          registration_email: {
            required: 'Povinné pole',
            email: 'Zadejte emailovou adresu'
          },
          registration_password: {
            required: 'Povinné pole',
            regex: 'Heslo musí obsahovat číslici a velké písmeno',
            minlength: 'Heslo musí obsahovat minimálně 8 znaků'
          },
          registration_confirm: {
            required: 'Povinné pole',
            equalTo: 'Hesla se musí shodovat'
          }
        },
        errorPlacement: function(error, element) {
          var wrapper = element.closest('.input-wrapper');
          var errorLabel = wrapper.find('.error-label');
          if (errorLabel.length) {
            errorLabel.html(error.text());
          } else {
            error.insertBefore(element);
          }
        },
        success: function(label, element) {
          var wrapper = $(element).closest('.input-wrapper');
          var errorLabel = wrapper.find('.error-label');
          if (errorLabel.length) {
            errorLabel.html('');
          }
        }
      });
    }

  $('body').on('click', '#modalRegister .have-account', function () {
    $('#modalRegister').removeClass('active');
    $('#modalLogin').addClass('active').find('input').filter(':first').focus();
  })

  $('body').on('submit', '#registrationForm', function (e) {
    e.preventDefault(); // vždy zabráníme defaultnímu odeslání

    if (typeof registrationForm.valid === 'function' && registrationForm.valid()) {
        let form = $(this);
        form.find('button.registration-btn').addClass('is-loading');
        form.find('.modal-message-box').addClass('hidden');

        $.ajax({
            url: form.attr('action'),
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                if (data.status === 'ok') {
                    form.find('.modal-message-box.success-confirm').removeClass('hidden');
                    form.closest('.modal').find('.js-modal-close').focus();
                } else if (data.status === 'recaptcha-fail') {
                    form.find('.modal-message-box.recaptcha-fail').removeClass('hidden');
                    form.find('input').filter(':visible:not([disabled]):first').focus();
                } else {
                    form.find('.modal-message-box.existing-user').removeClass('hidden');
                    form.find('input').filter(':visible:not([disabled]):first').focus();
                }
            },
            error: function (xhr, status, error) {
                form.find('.modal-message-box.existing-user').removeClass('hidden');
                console.error('Chyba AJAX:', status, error, xhr.responseText);
            }
        }).always(function () {
            form.find('button.registration-btn').removeClass('is-loading');
        });

    } else {
        if (typeof registrationForm.validate === 'function') {
            registrationForm.validate().focusInvalid();
        }
    }
  });


  // Modální okno pro registraci
  if (resetPasswordForm.length) {
    resetPasswordForm.validate({
      focusInvalid: true,
      rules: {
        reset_password: {
          minlength: 8,
          regex: '((?=.*[0-9])(?=.*[A-Z]))'
        },
        reset_confirm: {
          equalTo: '#resetPassword'
        }
      },
      messages: {
        reset_password: {
          required: 'Povinné pole',
          regex: 'Heslo musí obsahovat číslici a velké písmeno',
          minlength: 'Heslo musí obsahovat minimálně 8 znaků'
        },
        reset_confirm: {
          required: 'Povinné pole',
          equalTo: 'Hesla se musí shodovat'
        }
      },
      errorPlacement: function(error, element) {
        var wrapper = element.closest('.input-wrapper');
        var errorLabel = wrapper.find('.error-label');
        if (errorLabel.length) {
          errorLabel.html(error.text());
        } else {
          error.insertBefore(element);
        }
      },
      success: function(label, element) {
        var wrapper = $(element).closest('.input-wrapper');
        var errorLabel = wrapper.find('.error-label');
        if (errorLabel.length) {
          errorLabel.html('');
        }
      }
    })
  }

  $('body').on('click', '#resetPasswordForm .recover-btn', function (e) {

    if (resetPasswordForm.valid()) {
      e.preventDefault();

      let form = $(this).closest('form');
      form.find('button.recover-btn').addClass('is-loading');
      form.find('.modal-message-box').addClass('hidden');

      $.ajax({
        url: form.attr('action'),
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          if (data.status === 'ok') {
            form.find('.modal-message-box.password-set-successfully').removeClass('hidden');
            form.closest('.modal').find('.js-modal-close').focus();
            form.find('button.recover-btn').attr('disabled', true);
            setTimeout(function() {
              window.location.href = '/';
            }, 5000);
          } else {
            form.find('.modal-message-box.password-link-expired').removeClass('hidden');
            form.closest('.modal').find('.js-modal-close').focus();
          }
        },
        error: function (xhr, status, error) {
          console.error('Chyba AJAX:', status, error, xhr.responseText);
          form.find('.modal-message-box.password-link-expired').removeClass('hidden');
        }
      }).always(function() {
        form.find('button.recover-btn').removeClass('is-loading');
      });

      } else {
      resetPasswordForm.validate().focusInvalid();
    }
  });

  // Newsletter Subscribe
  if (newsletterForm.length) {
    newsletterForm.validate({
      focusInvalid: false,
      messages: {
        newsletter_email: {
          required: 'Povinné pole',
          email: 'Zadejte emailovou adresu'
        },
      },
      invalidHandler: function (event, validator) {
        if (validator.errorMap.newsletter_email) {
          newsletterForm.parent(".input-wrapper").addClass("error");
        }
      },
      success: function () {
        newsletterForm.parent(".input-wrapper").removeClass("error");
      }
    });

    newsletterForm.bind("invalid-form.validate", function () {
      $('.modal-wrapper').addClass('open');
      $('#newsletter-warning').addClass('active').closest('.modal-wrapper').addClass('open');
      $('#newsletter-warning').find('.js-modal-close').last().focus();
    });

    $('#newsletter-warning').find('.js-modal-close').on('click', function() {
    $('#newsletterSubscribeForm').find('input[name="newsletter_email"]').focus();
    });


    $('#newsletter_email').on('blur keyup', function() {
        if (!$(this).valid()) {
            newsletterForm.parent(".input-wrapper").addClass("error");
        } else {
            newsletterForm.parent(".input-wrapper").removeClass("error");
        }
    });
  }

  //kalkulačka rizik
  $('.user-calculator-results .result-delete').on('click', function (e) {
    e.preventDefault();

    $('#calculatorDelete').addClass('active').closest('.modal-wrapper').addClass('open');
    $('#calculatorDelete').find('.confirm-remove').data('guid', $(this).data('guid'));
    $('#calculatorDelete').find('.close-btn').focus();
  });

  $('#calculatorDelete .confirm-remove').on('click', function (e) {
    e.preventDefault();

    let guid = $(this).data('guid');
    let item = $('.user-calculator-results .result-delete[data-guid="' + guid + '"]');

    let button = $(this);
    button.addClass('is-loading');

    $.ajax({
      url: '/wp-admin/admin-post.php',
      type: 'post',
      dataType: 'json',
      data: {
        action: 'exchange-rate-risk-calculator-delete',
        guid: item.data('guid'),
      },
      success: function (data) {
        button.removeClass('is-loading');

        if (data.success) {
          $('#calculatorDelete').removeClass('active').closest('.modal-wrapper').removeClass('open');

          const meta = item.closest('.result-meta');
          const numberBox = meta.prev('.number-box');
          const separator = meta.next('.separator');

          numberBox.remove();
          meta.remove();
          separator.remove();

        } else {
          alert('Ups, něco se porouchalo.');
        }
      },
    });
  });

  // Newsletter widget Subscribe
  if (nlwSubscribeForm.length) {
    nlwSubscribeForm.validate({
      focusInvalid: true,
      messages: {
        nwl_email: {
          required: 'Povinné pole',
          email: 'Zadejte emailovou adresu'
        },
      }
    })
  }

  $('body').on('submit', '#nlwSubscribeForm', function (e) {
    e.preventDefault();

    let form = $(this);

    if (nlwSubscribeForm.valid()) {
      $('.nlw-dynamic-content').html('<div class="nlw-response "><div class="icon"></div><div class="text">Odesílání...</div>');

      $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: form.serialize(),
        success: function (data) {
          if (data.status === 'ok') {
            window.localStorage.setItem('hideNewsletterWidget', true);

            $('.nlw-dynamic-content').html(`
              <div class="nlw-response success">
                <div class="icon"></div>
                <div class="text">
                  <strong>Žádost k odběru přijata.</strong><br>
                  Na Váš e-mail jsme zaslali žádost o potvrzení
                </div>
              </div>
            `);
          } else {
            $('.nlw-dynamic-content').html(`
              <div class="nlw-response error">
                <div class="icon"></div>
                <div class="text">
                  <strong>Odběr newsletteru</strong><br>
                  Na tuto e-mailovou adresu již je přijímán newsletter.
                </div>
              </div>
            `);
          }

          form[0].reset();
        },
        error: function () {
          $('.nlw-dynamic-content').html(`
            <div class="nlw-response error">
              <div class="icon"></div>
              <div class="text">
                <strong>Odběr newsletteru</strong><br>
                Ups, něco se pokazilo.
              </div>
            </div>
            `);
        }
      });

      e.preventDefault();
      //$('.nlw-dynamic-content').html(successTemp);
    } else {
      $('.nlw-dynamic-content').empty();
      let errorTemp = `
      <div class="nlw-response error">
        <div class="icon"></div>
        <div class="text">
          <strong>Odběr newsletteru</strong><br>
          Zadejte prosím e-mailovou adresu ve správném formátu.
        </div>
      </div>
      `

      $('.nlw-dynamic-content').append(errorTemp);
    }
  });

});
